module.exports = __webpack_public_path__ + "static/img/cont52 (2).58833dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont52 (2).jpg
// module id = HOTP
// module chunks = 0